import React, { useContext } from 'react';
import { FullReportContext } from '../../../../../../../Context/FullReportContext';
import {
  ProjectRow,
  ProjectValue
} from '../../../../../../../Models/ProjectValue';
import { MultipleReportsModalOption } from '../../../../../../../Components/MultipleReportsModal/MultipleReportsModalSelect/MultipleReportsModalSelect';

const RECENT_REPORTS_LIMIT = 10;

export interface UseProjectCardProps {
  project: ProjectValue;
}

export interface UseProjectCardReturnProps {
  isSeeRecentReportsBtnDisabled: boolean;
  onSeeDateRowReports: (index: number) => void;
  onSeeRecentReports: () => void;
}

export const UseProjectCard = ({
  project
}: UseProjectCardProps): UseProjectCardReturnProps => {
  const { showMultipleReports } = useContext(FullReportContext);

  const isSeeRecentReportsBtnDisabled =
    !project.rows || project.rows.length === 0;

  const onSeeRecentReports = React.useCallback(() => {
    let recentIncidents: MultipleReportsModalOption[] = [];

    project.rows.forEach((r: ProjectRow) => {
      if (recentIncidents.length >= RECENT_REPORTS_LIMIT) return;

      recentIncidents = [
        ...recentIncidents,
        ...(r.related_reports as unknown as MultipleReportsModalOption[])
      ];
    });

    if (recentIncidents.length > 0) {
      showMultipleReports(
        recentIncidents,
        undefined,
        recentIncidents[0].incident_number
      );
    }
  }, [showMultipleReports, project]);

  const onSeeDateRowReports = React.useCallback(
    (rowIndex: number) => {
      let rowIncidents: MultipleReportsModalOption[] = [];

      if (!project.rows || project.rows.length === 0 || !project.rows[rowIndex])
        return;

      rowIncidents = [
        ...rowIncidents,
        ...(project.rows[rowIndex]
          .related_reports as unknown as MultipleReportsModalOption[])
      ];

      if (rowIncidents.length > 0) {
        showMultipleReports(
          rowIncidents,
          undefined,
          rowIncidents[0].incident_number
        );
      }
    },
    [showMultipleReports, project]
  );

  return {
    isSeeRecentReportsBtnDisabled,
    onSeeDateRowReports,
    onSeeRecentReports
  };
};
